import React from "react";
import { createRoot } from "react-dom/client";
import { configureAuth, authHttpClient } from "@webmotors/consumer-shared-auth";
import "@webmotors/consumer-shared-ui/styles.css";
import "@styles/reset.css";
import { App } from "./app";
import {
  exposeBuildVersion,
  initDatadog,
  setupAxiosObservability,
  ObservabilityErrorBoundary,
} from "@/infra/observability";

if (!import.meta.env.VITE_AUTH_ENV) {
  throw new Error("VITE_AUTH_ENV is required");
}

configureAuth({
  env: import.meta.env.VITE_AUTH_ENV,
  loginUrl: import.meta.env.VITE_URL_LOGIN,
});

exposeBuildVersion();
initDatadog();
setupAxiosObservability(authHttpClient);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ObservabilityErrorBoundary>
      <App />
    </ObservabilityErrorBoundary>
  </React.StrictMode>,
);
